import styled from 'styled-components';
import { Row, Col, Carousel } from 'react-bootstrap';

export const Nav = styled.nav`
  background-color: ${props => props.backcolor};
  color: ${props => props.color};
  padding: ${props => props.pad};
  border-bottom: ${props => props.bordercolor};
  font-size: ${props => props.textSize};
  top: 0;
  z-index: 5;
  display: flex;
  position: sticky;
  justify-content: center;
  border-style: solid;
  border-top: transparent;
  border-right: transparent;
  border-left: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${props => props.height};
  width: 100%;
`;

export const TextChild = styled.div`
  background-color: ${props => props.textBackcolor};
  color: ${props => props.textColor};
  font-size: ${props => props.textSize};
  top: 0;
  z-index: 5;
  position: relative;
  text-align: center;
`;

export const ChildContainer = styled.div`
  height: calc(100% - ${props => props.heightToRemove});
  width: 100%;
`;

export const GridContainer = styled.div`
  background-color: ${props => props.backgroundcolor};
  height: calc(100% - ${props => (props.fullScreen ? '0px' : props.heightToRemove)});
`;

export const Grid = styled(Row)`
  height: 100%;
  width: 100%;
  margin: 0px;
  padding: 0px;
`;

export const GridChildrenContainer = styled(Row)`
  height: 100%;
  margin: 0;
  padding: 0;
`;

export const GridOnlyChild = styled(Col)`
  position: relative;
  text-align: center;
  overflow: hidden;
  background-color: ${props => props.backgroundcolor};
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 5px;
`;

export const GridTopChild = styled(Col)`
  position: relative;
  text-align: center;
  overflow: hidden;
  background-color: ${props => props.backgroundcolor};
  height: ${props => props.height};
  max-height: 100%;
  width: 100%;
  margin: 0;
  padding: 5px;
`;

export const GridBottomChild = styled(Col)`
  position: relative;
  text-align: center;
  overflow: hidden;
  background-color: ${props => props.backgroundcolor};
  height: ${props => props.height};
  max-height: 100%;
  width: 100%;
  margin: 0;
  padding: 5px;
`;

export const GridLeftChild = styled(Col)`
  position: relative;
  text-align: center;
  overflow: hidden;
  background-color: ${props => props.backgroundcolor};
  max-height: 100%;
  min-height: max(33%, 100px);
  width: 100%;
  padding: 5px;
`;

export const GridRightChild = styled(Col)`
  position: relative;
  text-align: center;
  overflow: hidden;
  background-color: ${props => props.backgroundcolor};
  max-height: 100%;
  min-height: max(67%, 200px);
  width: 100%;
  padding: 5px;
`;
export const GridMiddleChild = styled(Col)`
  position: relative;
  overflow: auto;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: ${props => props.backgroundcolor};
  max-height: 100%;
  min-height: max(${props => props.height}, 100px);
  padding: 5px;
`;

export const GridTopLeftChild = styled(Col)`
  position: relative;
  overflow: hidden;
  height: ${props => props.height};
  padding-bottom: ${props => (props.horizontal ? '0' : '5px')};
  padding-left: 0;
  padding-right: ${props => (props.horizontal ? '5px' : '0')};
  padding-top: 0;
`;

export const GridTopRightChild = styled(Col)`
  position: relative;
  overflow: hidden;
  height: ${props => props.height};
  padding-bottom: ${props => (props.horizontal ? '0' : '5px')};
  padding-left: ${props => (props.horizontal ? '5px' : '0')};
  padding-right: 0;
  padding-top: 0;
`;

export const GridBottomLeftChild = styled(Col)`
  position: relative;
  overflow: hidden;
  height: ${props => props.height};
  padding-bottom: 0;
  padding-left: 0;
  padding-right: ${props => (props.horizontal ? '5px' : '0')};
  padding-top: ${props => (props.horizontal ? '0' : '5px')};
`;

export const GridBottomRightChild = styled(Col)`
  position: relative;
  overflow: hidden;
  padding: 5px;
  height: ${props => props.height};
  padding-bottom: 0;
  padding-left: ${props => (props.horizontal ? '5px' : '0')};
  padding-right: 0;
  padding-top: ${props => (props.horizontal ? '0' : '5px')};
`;

export const GridMiddleLeftChild = styled(Col)`
  position: relative;
  overflow: hidden;
  height: ${props => props.height};
  padding-bottom: ${props => (props.horizontal ? '0' : '5px')};
  padding-left: 0;
  padding-right: ${props => (props.horizontal ? '5px' : '0')};
  padding-top: ${props => (props.horizontal ? '0' : '5px')};
`;

export const GridMiddleRightChild = styled(Col)`
  position: relative;
  overflow: hidden;
  height: ${props => props.height};
  padding-bottom: ${props => (props.horizontal ? '0' : '5px')};
  padding-left: ${props => (props.horizontal ? '5px' : '0')};
  padding-right: 0;
  padding-top: ${props => (props.horizontal ? '0' : '5px')};
`;

export const GridHorizontalMiddleChild = styled(Col)`
  position: relative;
  overflow: hidden;
  height: ${props => props.height};
  padding-bottom: 0;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 0;
`;

export const GridTaskMonitorContainer = styled.div`
  background-color: white;
  border-radius: 15px;
  height: 100%;
`;

export const ExpandButtonContainer = styled.div`
  visibility: ${props => (props.showButton ? 'visible' : 'hidden')};
  transition: visibility 0.3s;
`;

export const LinkButtonContainer = styled.a`
  visibility: ${props => (props.showButton ? 'visible' : 'hidden')};
  transition: visibility 0.3s;
`;

const BUTTON_SIZE = 40;
const LEFT_MARGIN = 1;

const getLeftMargin = ({ numberOfButtonsLeft }) => {
  return LEFT_MARGIN + BUTTON_SIZE * numberOfButtonsLeft;
};

export const AtlasButtonImg = styled.img`
  position: absolute;
  bottom: 0px;
  width: ${props => (props.showButton ? '35px' : '0px')};
  height: ${props => (props.showButton ? '35px' : '0px')};
  left: ${props => getLeftMargin(props)}px;
  transition: width 0.3s, height 0.3s;
  z-index: 3;
  cursor: pointer;
`;

export const SectionContainer = styled.div`
  height: calc(100% - 75px);
  width: 100%;
  position: relative;
`;

export const Section = styled.section`
  height: ${props => props.height};
  width: 100%;
  position: relative;
`;

export const IframeNoBorder = styled.iframe`
  border: 0px;
  position: ${props => (props.isFullScreen ? 'fixed' : '')};
`;

export const StyledCarousel = styled(Carousel)`
  a.carousel-control-prev,
  a.carousel-control-next {
    height: 30px;
    margin-top: calc(50vh - 70px);
  }
  span.carousel-control-prev-icon,
  span.carousel-control-next-icon {
    filter: invert(1);
  }
  ol.carousel-indicators li {
    filter: invert(1);
  }
`;
